import {getActionSpec} from './catalog';
import {upcomingOccasions,type PersonProfile} from './people';
import type {Decision} from './storage';

export function findPeople(people:PersonProfile[],query:string,sort:string,now=new Date()){
 const term=query.trim().toLocaleLowerCase();
 return people.filter(person=>person.nickname.toLocaleLowerCase().includes(term)).slice().sort((a,b)=>sort==='name'?a.nickname.localeCompare(b.nickname,'ko'):sort==='occasion'?(upcomingOccasions([a],now,366)[0]?.daysUntil??999)-(upcomingOccasions([b],now,366)[0]?.daysUntil??999):b.updatedAt.localeCompare(a.updatedAt));
}
export type DecisionFilter={query:string;personId:string;occasion:string;year:string;pendingOnly:boolean};
export function findDecisions(items:Decision[],people:PersonProfile[],filter:DecisionFilter,labels:Record<string,string>){
 const term=filter.query.trim().toLocaleLowerCase();
 return items.filter(item=>{
  const person=people.find(value=>value.id===item.personId);
  const linked=person?.gifts.filter(gift=>gift.decisionId===item.id).map(gift=>gift.title)??[];
  const action=getActionSpec(item.selectedActionId);
  const text=[labels[item.brief.occasion],labels[item.brief.relation],person?.nickname,action?.title,action?.option,...linked,...item.results.map(result=>result.name)].join(' ').toLocaleLowerCase();
  return text.includes(term)&&(!filter.personId||item.personId===filter.personId)&&(!filter.occasion||item.brief.occasion===filter.occasion)&&(!filter.year||item.createdAt.startsWith(filter.year))&&(!filter.pendingOnly||!item.outcome);
 });
}
